/**
 * newElement
 * 
 * Создаёт новый DOM-элемент с указанным типом, классом и HTML
 * 
 * @param {String}          type 
 * @param {String, Array}   className 
 * @param {String}          innerHtml 
 * 
 * @returns {Element} Созданный DOM-элемент
 */
export default function newElement(type = 'div', className = '', innerHtml = '') {

    const element = document.createElement(type)

    typeof className == 'string' ? 
        element.className = className : 
        element.classList.add(...className)

    element.innerHTML = innerHtml

    return element
}